import { IState } from "./state";
import { ActionTree, Store, ActionContext } from 'vuex';
import * as api from '../api';
import { ISearchParams } from "../api";
import qs from 'query-string';

type PayloadType = 'initApp' | 'setState' |
'setQuery' | 'setLoading' |
'setHits' | 'setTotal' |
'search' | 'setSuggestion'
export type ActionPayload<ActionData> = {
	type: PayloadType,
	payload: ActionData
}

type ActionHandler<ActionData> = (this: Store<IState>, injectee: ActionContext<IState, IState>, payload: ActionPayload<ActionData>) => any;
type ActionCreator<ActionData> = (data: ActionData) => ActionPayload<ActionData>;


// Action creators
export const initApp: ActionCreator<IState> = (state) => ({
	type: 'initApp',
	payload: state
})

export const search: ActionCreator<string> = (payload) => ({
	type: 'search',
	payload
})

// Action handlers
const initAppAction: ActionHandler<IState> = ({ commit, state }, { payload }) => {
	commit({
		type: 'setState',
		payload
	})
}

const searchAction: ActionHandler<string> = ({ commit, state }) => {
	
	let searchParams: ISearchParams = {
		query: state.query,
		numberToShow: state.numberToShow,
		types: state.selectedTypes,
	}

	let filters = state.filters;

	filters.forEach(f => {
		let fParamArr: string[] = [];
		f.options.forEach(option =>{
			if(option.selected) {
				fParamArr.push(option.name)
			}
		})
		searchParams[f.name] = fParamArr.join(',')
	})

	commit({
		type: 'setLoading',
		payload: true
	})

	api.search(state.url, searchParams)
		.then(res => {
			commit({
				type: 'setHits',
				payload: res.hits
			})
			commit({
				type: 'setTotal',
				payload: res.total
			})

			if(state.total == 0) {
				commit({
					type: 'setSuggestion',
					payload: res.suggestion
				})
			}
		})

	commit({
		type: 'setLoading',
		payload: false
	})

	let url = `?${qs.stringify(searchParams)}`;
	window.history.replaceState({}, document.title, url);
}

const actions: ActionTree<IState, IState> = {
	initApp: initAppAction,
	search: searchAction,
}

export default actions;
